import { PaletteMode } from "@mui/material/styles";


/*
  Core Connect
 */

export const coreDarkTheme = {
  palette: {
    mode: "dark" as PaletteMode,
    primary: {
      main: "#82e1f2",
      light: "#b3edf7",
      dark: "#00b1cc",
      contrastText: "#212b3a",
    },
    secondary: {
      main: "#F5B49F",
      light: "#f8d1c4",
      dark: "#EA673B",
      contrastText: "#212b3a",
    },
    info: {
      main: "#e6f0ff",
      light: "#eef8ff",
      dark: "#cad4ec",
      contrastText: "#212b3a",
    },
    warning: {
      main: "#ffe081",
      light: "#fff8e1",
      dark: "#ffb200",
      contrastText: "#212b3a",
    },
    error: {
      main: "#fa8996",
      light: "#ffe8ee",
      dark: "#df5678",
      contrastText: "#212b3a",
    },
    background: {
      default: "#1C2636",
      paper: "#1C2636",
    },
    divider: "#58616c",
    gradient: [
      "#354a5f",
      "#446e89",
      "#4f96b3",
      "#59bfdb",
      "#66ebff"
    ]
  },
  typography: {
    fontFamily: "cera-pro",
  },
  components: {
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
  },
}

export const coreLightTheme = {
  palette: {
    mode: "light" as PaletteMode,
    primary: {
      main: "#00b1cc",
      light: "#82e1f2",
      dark: "#00656D",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#EA673B",
      light: "#F5B49F",
      dark: "#b54c29",
      contrastText: "#ffffff",
    },
    info: {
      main: "#1C2636",
      light: "#404956",
      dark: "#0B1627",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#ffb200",
      light: "#FFE081",
      dark: "#ff6e00",
      contrastText: "#212b3a",
    },
    error: {
      main: "#f3002c",
      light: "#fa8996",
      dark: "#c30013",
      contrastText: "#ffffff",
    },
    background: {
      default: "#fff",
      paper: "#F3F5F9",
    },
    action: {
      active: "#212b3a",
    },
    divider: "#BBBCBF",
    gradient: [
      "#354a5f",
      "#446e89",
      "#4f96b3",
      "#59bfdb",
      "#66ebff"
    ]
  },
  typography: {
    fontFamily: "cera-pro",
    allVariants: {
      color: "#212b3a",
    },
  },
  components: {
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
  },
}


/*
  Gravity Connect
 */

export const gravityDarkTheme = {
  palette: {
    mode: "dark" as PaletteMode,
    primary: {
      main: "#cb8af9",
      light: "#e0b9fa",
      dark: "#B557F7",
      contrastText: "#000000",
    },
    secondary: {
      main: "#cb8af9",
      light: "#e0b9fa",
      dark: "#B557F7",
      contrastText: "#000000",
    },
    info: {
      main: "#e6f0ff",
      light: "#eef8ff",
      dark: "#cad4ec",
      contrastText: "#212b3a",
    },
    warning: {
      main: "#ffe081",
      light: "#fff8e1",
      dark: "#ffb200",
      contrastText: "#212b3a",
    },
    error: {
      main: "#fa8996",
      light: "#ffe8ee",
      dark: "#df5678",
      contrastText: "#212b3a",
    },
    gradient: [
      "#f7d7ff",
      "#d5a5e6",
      "#b175ce",
      "#8b45b6",
      "#61089f"
    ]
  },
  typography: {
    fontFamily: "cera-pro",
  },
  components: {
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
  },
}

export const gravityLightTheme = {
  palette: {
    mode: "light" as PaletteMode,
    primary: {
      main: "#B557F7",
      light: "#cb8af9",
      dark: "#8841B9",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#B557F7",
      light: "#cb8af9",
      dark: "#8841B9",
      contrastText: "#ffffff",
    },
    info: {
      main: "#1C2636",
      light: "#404956",
      dark: "#0B1627",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#ffb200",
      light: "#FFE081",
      dark: "#ff6e00",
      contrastText: "#212b3a",
    },
    error: {
      main: "#f3002c",
      light: "#fa8996",
      dark: "#c30013",
      contrastText: "#ffffff",
    },
    background: {
      default: "#fff",
      paper: "#F3F5F9",
    },
    action: {
      active: "#212b3a",
    },
    divider: "#BBBCBF",
    gradient: [
      "#f7d7ff",
      "#d5a5e6",
      "#b175ce",
      "#8b45b6",
      "#61089f"
    ]
  },
  typography: {
    fontFamily: "cera-pro",
    allVariants: {
      color: "#212b3a",
    },
  },
  components: {
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
  },
}
